export default "__VITE_ASSET__2e42957f__"